import { generateInitials } from "./generateInitials";

export function getOwnerData(owner) {
  return {
    ...owner,
    avatar_color: owner.avatar_color ?? undefined,
    initials: generateInitials(
      owner.first_name,
      owner.last_name,
      owner.email,
    ),
    prettyName: prettyName(owner.first_name, owner.last_name, owner.email),
  }
}

export function prettyName(firstName, lastName, email) {
  if (!firstName && !lastName) {
    return email
  }

  return `${firstName} ${lastName} (${email})`
}